// src/data/faqData.js

const faqData = [
    {
      question: "Who can participate?",
      answer:
        "●  This competition embraces an open registration to anyone worldwide. \n ●  This competition allows participants to enter either individually or as a team, with a maximum of four members per team. \n ●  All team members must be at least 18. \n ●  Teams can be composed by members of different nationalities and there are no restrictions about country of residence \n ●  There is no restriction on the citizenship of the participants."
    },
    {
      question: "How to register?",
      answer:
        "Sign-up on the official competition website through the register/sign in tab and pay the required fees. Download the PDF brief to know all the competition details."
    },
    {
      question: "What is the entry or registration fee and how to pay? ",
      answer:
        "●  Student Registration - $60 / team \n ●  Professional Registration - $100 / team \n ●  Special invites may have a discount \n \n Payment methods are either PayPal, credit or debit"
    },
    {
      question: "How to pay the registration fee if PayPal, Debit, and credit are unavailable in the region?",
      answer:
        "Ask a friend from another country where PayPal is supported to complete the payment for you. Once they have done so, please send us both the proof of payment (screenshot of the PayPal receipt) and the transaction ID. This method is generally the most convenient. \n * If you are still stuck please contact us "
    },
    {
      question: "What is the deadline time?",
      answer:
        " The submission closes on January 30th, 2026 at 11:59 pm UTC (Coordinated Universal Time). Please submit beforehand to avoid any issues that may arise. "
    },
    {
        question: "What is the rule on the AI-generated graphics?",
        answer:
          "Unedited AI-generated graphics are not allowed, but AI is welcomed as a tool in the design process."
      },
      {
        question: "What if changes are needed for the registered team members?",
        answer:
          "You can edit the members before the submission deadline in your portal."
      },
      {
        question: "Is the specified program area intended to be a maximum, minimum, or fixed size?",
        answer:
          "The provided program  is intended as a guideline. Any justified adjustments are permissible, but any significant deviations must be explicitly justified within the proposal."
      }
  ];
  
  export default faqData;
  
